module.exports = __webpack_public_path__ + "static/landing-banner-background.60391828.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-banner-background.jpg
// module id = 1156
// module chunks = 213534597649335